var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSolaires(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.4974 165.402L92.6774 99.7816H180.307C179.987 96.9216 174.437 54.0717 136.087 35.7517C107.797 22.2417 81.2475 31.4216 76.9675 32.9816C52.4875 41.8916 33.0374 63.3116 27.6174 90.2816C22.0174 118.162 32.3974 147.072 54.5074 165.402H54.4974Z",
    fill: "#F97E73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.187 213.241L26.8773 212.891L26.8274 222.631L158.097 222.981L158.187 213.241Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M224.098 99.7916L158.148 213.252L158.098 222.982L224.008 109.542L224.098 99.7916Z",
    fill: "#72D09A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M150.328 199.632L171.288 163.322H129.378L108.408 199.632H150.328Z",
    fill: "#72D09A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5176 199.632H87.4376L108.398 163.322H66.4777L45.5176 199.632Z",
    fill: "#72D09A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9177 108.872L76.9578 145.182H118.878L139.838 108.872H97.9177Z",
    fill: "#72D09A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.848 145.172H181.768L202.728 108.862H160.808L139.848 145.172Z",
    fill: "#72D09A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6777 99.7916L26.8777 212.892L158.188 213.242L224.098 99.7916H92.6777ZM71.7278 145.182L92.6877 108.872L95.3077 104.332H147.708L121.518 149.722H69.1078L71.7278 145.182ZM90.0577 204.172H37.6677L61.2477 163.322L63.8677 158.782H116.258L113.638 163.322L92.6777 199.632L90.0577 204.172ZM176.518 163.322L155.558 199.632L152.938 204.172H100.538L103.158 199.632L124.118 163.322L126.728 158.782H179.138L176.518 163.322ZM186.998 145.172L184.378 149.712H131.978L134.588 145.172L155.558 108.862L158.168 104.322H210.578L207.958 108.862L186.998 145.172Z",
    fill: "#72D09A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolaires);
export default __webpack_public_path__ + "static/media/solaires.7ab103824e2f72af49af6898b964b801.svg";
export { ForwardRef as ReactComponent };